







































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import allTrain from "@/views/train/allTrain.vue";
import myTrain from "@/views/train/myTrain.vue";
import trainMap from "@/views/train/trainMap.vue";
import util from "@/lib/util";
import ShortHeaderLayout from "@/layouts/shortHeaderLayout.vue";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import DescriptionList from "@/components/DescriptionList/DescriptionList.vue";
import DescriptionListItem from "@/components/DescriptionList/DescriptionListItem.vue";
import SectionLayout from "@/layouts/sectionLayout.vue";
import AppConsts from "@/lib/appconst";
import moment from 'moment';


@Component({
    components: {SectionLayout, ShortHeaderLayout, basicPage, DescriptionList, DescriptionListItem, trainMap}
})
export default class trainDetail extends basicPage {
    @Prop({type: String, default: ''}) trainId: string;

    routeTokens:any= {};
    data: any = [];
    tableData: any = [];
    tabPage = false;
    rowSelection = {
        selectedRowKeys: [],
        hideDefaultSelections: true,
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            this.rowSelection.selectedRowKeys = selectedRowKeys;
        },
        onSelect: (record, selected, selectedRows) => {
            console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log(selected, selectedRows, changeRows);
        },
        onSelectInvert: (selectedRows) => {
            console.log(selectedRows)
        }
    };

    tableColumn = [
        {
            title: "文件名",
            dataIndex: "filename",
        },
        {
            title: "文件类型",
            dataIndex: "filetype",
            width: 120
        },
        {
            title: "文件大小",
            dataIndex: "filesize",
            width: 120
        },
        {
            title: '操作',
            dataIndex: 'cz',
            scopedSlots: {customRender: 'cz'},
            width: 120
        },
    ]
    showApply = false;  //判断当前用户对于当前培训是否报过名

    loadData() {
        let self = this;
        ajaxHelperInstance.get('web/meeting/search/getTrainListByid', {pxid: self.trainId}).then((res) => {
            let {data, errno, message} = res.data;
            if (data.length == 0) {
                return;
            }

            data = data[0];
            self.data = data;
            // if(data.applyState){
            //     self.data.meetingState = 4;
            // }

            // self.defRoutes.push({
            //     path: '/trainDetail',
            //     breadcrumbName: data.title,
            // });

            this.routeTokens = {
                'pxtitle':data.title
            }

            if (data) {
                self.tableData = data.meetingFile == undefined ? [] : data.meetingFile;
                self.tableData.forEach(function (item, index) {
                    let size =  Math.ceil(item.filesize / 1000);
                    item.filesize = size + "KB"
                });
            }
        })
    }

    getDownloadLink(obj) {
        let path = obj.filepath;
        let fileName = obj.filename;
        //url文件数据库保存的文件路径
        ajaxHelperInstance.getOneFile('web/meeting/download/downloadFile',{path}).then((res) => {
            let blob = new Blob([res.data])
            let url = window.URL.createObjectURL(blob)
            const link = document.createElement('a') // 创建a标签
            link.href = url
            link.download = fileName // 重命名文件
            link.click()
            URL.revokeObjectURL(url) // 释放内存
        })
    }

    downloadAll() {
        let tmpRes = this.rowSelection.selectedRowKeys;
        ajaxHelperInstance.postdown('web/meeting/download/downloadFiles',tmpRes).then((res) => {
            let blob = new Blob([res.data], {type: 'application/zip'})
            let url = window.URL.createObjectURL(blob)
            const link = document.createElement('a') // 创建a标签
            link.href = url
            link.download = this.data.title + '资料文件' // 重命名文件
            link.click()
            URL.revokeObjectURL(url) // 释放内存
        })
    }

    defRoutes = [{
        path: 'train',
        breadcrumbName: '培训报名',
    }]


    getMeetingStateName(state,isApply) {
        let arr = {
            1: '报名未开始',
            2: '正在报名',
            3: '报名结束',
            4: '培训结束',
        }

        let dtNow = moment().format('x');

        // if(isApply || state == 2){
        //     state=2;
        // }

        return arr[state];
    }

    getMeetingStateColor(state,isApply) {
        let arr = {
            1: '#FFE58F',
            2: 'rgba(246,255,237,1)',
            3: 'rgba(0,0,0,0.04)',
            4: 'rgba(0,0,0,0.04)'
        }
        // if(isApply){
        //     state=4;
        // }
        return arr[state];
    }


    getColor(state){
        let arr = {
            1: '#FAAD14',
            2: '#52C41A',
            3: 'rgba(0,0,0,0.65)',
            4: 'rgba(0,0,0,0.65)'
        }

        let borderColor = {
            1: 'rgba(255,229,143,1)',
            2: 'rgba(183,235,143,1)',
            3: 'rgba(0,0,0,0.15)',
            4: 'rgba(0,0,0,0.15)'
        }

        let ret = `color:${arr[state]};border:1px solid ${borderColor[state]};margin-right:20px`;
        return ret;
    }

    getApplyText(){

        let ret = '我要报名';
        if(this.showApply){
            ret = '查看我的培训信息';
        }
        return ret;
    }



    openApply(data) {
        // if (data.meetingState != 2) {
        //     return;
        // }
        this.$router.push({
            name: 'trainApply',
            params: {
                trainId: this.trainId,
                trainName: data.title,
                trainState : data.meetingState
            },
        })

    }

    //查看当前用户对本次培训是否存在报名信息
    loadApplyUser() {
        let _this = this;
        ajaxHelperInstance.get('/web/meeting/search/getSingUpList/' + _this.trainId, {
            page: 1,
            pageSize: 1000,
            isQueryUser:true,
        }).then((res) => {
            let {data, errno, message} = res.data;
            _this.showApply = (res.data.data == null ? false : true);
        })
    }


    mounted() {
        this.loadData();
        this.loadApplyUser();
    }
}
